/** A library wrapper for the npm package react-csv: https://www.npmjs.com/package/react-csv */
import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { CSVLink } from 'react-csv'
import { Wrapper } from './component.styles'

const CsvDownloadLink = ({
  children,
  data,
  filename,
  headers,
  autoClick = true,
}) => {
  const csvInstance = useRef()

  useEffect(() => {
    const dataHasPopulated =
      data.length > 0 && csvInstance.current && csvInstance.current.link
    if (dataHasPopulated) {
      const isDataValid = validateIncomingData()
      if (!isDataValid) {
        return null
      }
      const timeout = setTimeout(() => {
        autoClick && csvInstance.current.link.click()
      })
      return () => {
        clearTimeout(timeout)
      }
    }
  }, [data])

  const validateIncomingData = () => {
    const isFileNameValid = typeof filename === 'string'
    if (!isFileNameValid) {
      console.error('Filename must be a string')
      return false
    }
    const areHeadersValid =
      Array.isArray(headers) &&
      headers.every(item => {
        const { label, key } = item || {}
        return label && key
      })

    if (!areHeadersValid) {
      console.error('Headers should be a Array of objects:  ', headers)
      return false
    }
    const isDataValid =
      Array.isArray(data) &&
      data.every(item => {
        return typeof item === 'object' && item !== null
      })
    if (!isDataValid) {
      console.error('Data should be a Array of objects: ', data)
      return false
    }
    return true
  }
  const isAllCSVDataValid = validateIncomingData()

  if (!isAllCSVDataValid) return null
  return (
    <Wrapper>
      <CSVLink
        data={data}
        filename={filename}
        headers={headers}
        ref={csvInstance}
      >
        {children}
      </CSVLink>
    </Wrapper>
  )
}

CsvDownloadLink.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  data: PropTypes.array,
  filename: PropTypes.string,
  headers: PropTypes.array,
}

export default CsvDownloadLink



// WEBPACK FOOTER //
// ./src/components/CsvDownloadLink/component.jsx